var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "contrasena_firma_electronica",
                  placeholder: "Ingrese la contraseña..."
                },
                model: {
                  value: _vm.form.password_firma_digital,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "password_firma_digital", $$v)
                  },
                  expression: "form.password_firma_digital"
                }
              },
              [
                _c("span", [_vm._v("Contraseña de firma electrónica")]),
                _vm._v(" "),
                _vm.errores.password_firma_digital
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.password_firma_digital[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "contrasena_firma_electronica_confirmation",
                  placeholder: "Confirme la contraseña..."
                },
                model: {
                  value: _vm.form.password_firma_digital_confirmation,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "password_firma_digital_confirmation",
                      $$v
                    )
                  },
                  expression: "form.password_firma_digital_confirmation"
                }
              },
              [
                _c("span", [
                  _vm._v("Confirme la contraseña de la firma electrónica")
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "nombre_firma_electronica",
                  placeholder: "Nombre en el archivo de la firma"
                },
                model: {
                  value: _vm.form.nombre_firma_electronica,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nombre_firma_electronica", $$v)
                  },
                  expression: "form.nombre_firma_electronica"
                }
              },
              [
                _c("span", [_vm._v("Nombre de archivo de firma electrónica")]),
                _vm._v(" "),
                _vm.errores.nombre_firma_electronica
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.nombre_firma_electronica[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "descripcion",
                  placeholder: "Seleccione...",
                  id: "tipoAmbiente",
                  options: _vm.tiposAmbiente
                },
                model: {
                  value: _vm.selectedTipoAmbiente,
                  callback: function($$v) {
                    _vm.selectedTipoAmbiente = $$v
                  },
                  expression: "selectedTipoAmbiente"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipoAmbiente" } }, [
                _vm._v("Tipo de ambiente")
              ]),
              _vm._v(" "),
              _vm.errores.id_tipo_ambiente
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errores.id_tipo_ambiente[0]) +
                          "\n          "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "smtp_user",
                  placeholder: "Usuario SMTP"
                },
                model: {
                  value: _vm.form.smtp_user,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_user", $$v)
                  },
                  expression: "form.smtp_user"
                }
              },
              [
                _c("span", [_vm._v("Dirección electrónica SMTP (Usuario)")]),
                _vm._v(" "),
                _vm.errores.smtp_user
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_user[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "smtp_password",
                  placeholder: "Contraseña SMTP"
                },
                model: {
                  value: _vm.form.smtp_password,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_password", $$v)
                  },
                  expression: "form.smtp_password"
                }
              },
              [_c("span", [_vm._v("Contraseña SMTP (Usuario)")])]
            ),
            _vm._v(" "),
            _vm.errores.smtp_password
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errores.smtp_password[0]) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "smtp_password_confirmation",
                  placeholder: "Confirmación SMTP"
                },
                model: {
                  value: _vm.form.smtp_password_confirmation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_password_confirmation", $$v)
                  },
                  expression: "form.smtp_password_confirmation"
                }
              },
              [_c("span", [_vm._v("Confirmar contraseña SMTP (Usuario)")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "motivo_correo",
                  placeholder: "Escriba el motivo..."
                },
                model: {
                  value: _vm.form.motivo_correo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "motivo_correo", $$v)
                  },
                  expression: "form.motivo_correo"
                }
              },
              [
                _c("span", [_vm._v("Motivo de correo (Facturación)")]),
                _vm._v(" "),
                _vm.errores.motivo_correo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.motivo_correo[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "servidor_smtp",
                  placeholder: "Host SMTP"
                },
                model: {
                  value: _vm.form.smtp_host,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_host", $$v)
                  },
                  expression: "form.smtp_host"
                }
              },
              [
                _c("span", [_vm._v("Servidor SMTP de correos")]),
                _vm._v(" "),
                _vm.errores.smtp_host
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.smtp_host[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  type: "number",
                  id: "puerto_servidor",
                  placeholder: "Puerto SMTP"
                },
                model: {
                  value: _vm.form.smtp_port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_port", $$v)
                  },
                  expression: "form.smtp_port"
                }
              },
              [
                _c("span", [_vm._v("Puerto en el servidor")]),
                _vm._v(" "),
                _vm.errores.smtp_port
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.smtp_port[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("label", { attrs: { for: "servidor_smtp_usa_ssl" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.smtp_seguridad,
                  expression: "form.smtp_seguridad"
                }
              ],
              attrs: { type: "checkbox", id: "servidor_smtp_usa_ssl" },
              domProps: {
                checked: Array.isArray(_vm.form.smtp_seguridad)
                  ? _vm._i(_vm.form.smtp_seguridad, null) > -1
                  : _vm.form.smtp_seguridad
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.smtp_seguridad,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "smtp_seguridad", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "smtp_seguridad",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "smtp_seguridad", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("El servidor de correo SMTP usa SSL")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("label", { attrs: { for: "permitir_facturacion" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.permitir_facturacion,
                  expression: "form.permitir_facturacion"
                }
              ],
              attrs: { type: "checkbox", id: "permitir_facturacion" },
              domProps: {
                checked: Array.isArray(_vm.form.permitir_facturacion)
                  ? _vm._i(_vm.form.permitir_facturacion, null) > -1
                  : _vm.form.permitir_facturacion
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.permitir_facturacion,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.form,
                          "permitir_facturacion",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "permitir_facturacion",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "permitir_facturacion", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Permitir facturación")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_facturacion,
                    expression: "form.tipo_facturacion"
                  }
                ],
                attrs: { name: "tipo_facturacion", id: "tipo_facturacion" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_facturacion",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "OF" } }, [_vm._v("Offline")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "ON" } }, [_vm._v("Online")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo_facturacion" } }, [
              _vm._v("Tipo de facturación")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  type: "number",
                  id: "minutos_firma",
                  placeholder: "(En minutos)"
                },
                model: {
                  value: _vm.form.minutos_firma,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "minutos_firma", $$v)
                  },
                  expression: "form.minutos_firma"
                }
              },
              [
                _c("span", [_vm._v("Intervalo de firma de documentos")]),
                _vm._v(" "),
                _vm.errores.minutos_firma
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.minutos_firma[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  type: "number",
                  id: "minutos_autorizacion",
                  placeholder: "(En minutos)"
                },
                model: {
                  value: _vm.form.minutos_autorizacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "minutos_autorizacion", $$v)
                  },
                  expression: "form.minutos_autorizacion"
                }
              },
              [
                _c("span", [_vm._v("Intervalo de autorización de documentos")]),
                _vm._v(" "),
                _vm.errores.minutos_autorizacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.minutos_autorizacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  type: "number",
                  id: "minutos_email",
                  placeholder: "(En minutos)"
                },
                model: {
                  value: _vm.form.minutos_email,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "minutos_email", $$v)
                  },
                  expression: "form.minutos_email"
                }
              },
              [
                _c("span", [_vm._v("Intervalo de envío de correos")]),
                _vm._v(" "),
                _vm.errores.minutos_email
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.minutos_email[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "servidor_smtp",
                  placeholder: "Nombre de fichero"
                },
                model: {
                  value: _vm.form.path_correo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "path_correo", $$v)
                  },
                  expression: "form.path_correo"
                }
              },
              [
                _c("span", [_vm._v("Plantilla de correo (HTML)")]),
                _vm._v(" "),
                _vm.errores.path_correo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.path_correo[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "plantilla_factura",
                  placeholder: "Nombre de fichero"
                },
                model: {
                  value: _vm.form.path_factura,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "path_factura", $$v)
                  },
                  expression: "form.path_factura"
                }
              },
              [
                _c("span", [_vm._v("Plantilla de factura (HTML)")]),
                _vm._v(" "),
                _vm.errores.path_factura
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.path_factura[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "plantilla_nc",
                  placeholder: "Nombre de fichero"
                },
                model: {
                  value: _vm.form.path_nota_credito,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "path_nota_credito", $$v)
                  },
                  expression: "form.path_nota_credito"
                }
              },
              [
                _c("span", [_vm._v("Plantilla de nota de crédito (HTML)")]),
                _vm._v(" "),
                _vm.errores.path_nota_credito
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.path_nota_credito[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "plantilla_retencion",
                  placeholder: "Nombre de fichero"
                },
                model: {
                  value: _vm.form.path_retencion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "path_retencion", $$v)
                  },
                  expression: "form.path_retencion"
                }
              },
              [
                _c("span", [_vm._v("Plantilla de retención (HTML)")]),
                _vm._v(" "),
                _vm.errores.path_retencion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.path_retencion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "plantilla_gr",
                  placeholder: "Nombre de fichero"
                },
                model: {
                  value: _vm.form.path_guia_remision,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "path_guia_remision", $$v)
                  },
                  expression: "form.path_guia_remision"
                }
              },
              [
                _c("span", [_vm._v("Plantilla de guía de remisión (HTML)")]),
                _vm._v(" "),
                _vm.errores.path_guia_remision
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.path_guia_remision[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "servidor_smtp",
                  placeholder: "##.##"
                },
                model: {
                  value: _vm.form.precision,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "precision", $$v)
                  },
                  expression: "form.precision"
                }
              },
              [
                _c("span", [_vm._v("Precisión de decimales")]),
                _vm._v(" "),
                _vm.errores.precision
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.precision[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "###",
                    expression: "'###'"
                  }
                ],
                attrs: { type: "tel", id: "servidor_smtp", placeholder: "###" },
                model: {
                  value: _vm.form.dias_alerta,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "dias_alerta", $$v)
                  },
                  expression: "form.dias_alerta"
                }
              },
              [
                _c("span", [_vm._v("Días de alerta de pago")]),
                _vm._v(" "),
                _vm.errores.dias_alerta
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.dias_alerta[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "imap_user",
                  placeholder: "Usuario IMAP"
                },
                model: {
                  value: _vm.form.imap_user,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imap_user", $$v)
                  },
                  expression: "form.imap_user"
                }
              },
              [
                _c("span", [_vm._v("Dirección electrónica IMAP (Usuario)")]),
                _vm._v(" "),
                _vm.errores.imap_user
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.imap_user[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "imap_password",
                  placeholder: "Contraseña IMAP"
                },
                model: {
                  value: _vm.form.imap_password,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imap_password", $$v)
                  },
                  expression: "form.imap_password"
                }
              },
              [
                _c("span", [_vm._v("Contraseña de usuario IMAP")]),
                _vm._v(" "),
                _vm.errores.imap_password
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.imap_password[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "imap_password_confirmation",
                  placeholder: "Confirmar contraseña IMAP"
                },
                model: {
                  value: _vm.form.imap_password_confirmation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imap_password_confirmation", $$v)
                  },
                  expression: "form.imap_password_confirmation"
                }
              },
              [
                _c("span", [
                  _vm._v("Confirmación de contraseña de usuario IMAP")
                ]),
                _vm._v(" "),
                _vm.errores.imap_password_confirmation
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.imap_password_confirmation[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "imap_host",
                  placeholder: "Host IMAP"
                },
                model: {
                  value: _vm.form.imap_host,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imap_host", $$v)
                  },
                  expression: "form.imap_host"
                }
              },
              [
                _c("span", [_vm._v("Servidor IMAP")]),
                _vm._v(" "),
                _vm.errores.imap_host
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.imap_host[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "######",
                    expression: "'######'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "imap_port",
                  placeholder: "Puerto IMAP"
                },
                model: {
                  value: _vm.form.imap_port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imap_port", $$v)
                  },
                  expression: "form.imap_port"
                }
              },
              [
                _c("span", [_vm._v("Puerto IMAP")]),
                _vm._v(" "),
                _vm.errores.imap_port
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.imap_port[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("p", [
          _c("label", { attrs: { for: "imap_tls" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.imap_tls,
                  expression: "form.imap_tls"
                }
              ],
              attrs: { type: "checkbox", name: "imap_tls", id: "imap_tls" },
              domProps: {
                checked: Array.isArray(_vm.form.imap_tls)
                  ? _vm._i(_vm.form.imap_tls, null) > -1
                  : _vm.form.imap_tls
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.imap_tls,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "imap_tls", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "imap_tls",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "imap_tls", $$c)
                  }
                }
              }
            }),
            _c("span", [_vm._v("SSL/TLS Imap")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "c_smtp_host",
                  placeholder: "Host SMTP"
                },
                model: {
                  value: _vm.form.c_smtp_host,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "c_smtp_host", $$v)
                  },
                  expression: "form.c_smtp_host"
                }
              },
              [
                _c("span", [_vm._v("Servidor SMTP")]),
                _vm._v(" "),
                _vm.errores.c_smtp_host
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.c_smtp_host[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "######",
                    expression: "'######'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "c_smtp_port",
                  placeholder: "Puerto SMTP"
                },
                model: {
                  value: _vm.form.c_smtp_port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "c_smtp_port", $$v)
                  },
                  expression: "form.c_smtp_port"
                }
              },
              [
                _c("span", [_vm._v("Puerto SMTP")]),
                _vm._v(" "),
                _vm.errores.c_smtp_port
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.c_smtp_port[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("p", [
          _c("label", { attrs: { for: "c_smtp_tls" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.c_smtp_tls,
                  expression: "form.c_smtp_tls"
                }
              ],
              attrs: { type: "checkbox", name: "c_smtp_tls", id: "c_smtp_tls" },
              domProps: {
                checked: Array.isArray(_vm.form.c_smtp_tls)
                  ? _vm._i(_vm.form.c_smtp_tls, null) > -1
                  : _vm.form.c_smtp_tls
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.c_smtp_tls,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "c_smtp_tls", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "c_smtp_tls",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "c_smtp_tls", $$c)
                  }
                }
              }
            }),
            _c("span", [_vm._v("SSL/TLS SMTP")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "smtp_alertas_host",
                  placeholder: "Host SMTP"
                },
                model: {
                  value: _vm.form.smtp_alertas_host,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_host", $$v)
                  },
                  expression: "form.smtp_alertas_host"
                }
              },
              [
                _c("span", [_vm._v("Servidor SMTP (Alertas de saldos)")]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_host
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_host[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "######",
                    expression: "'######'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "smtp_alertas_port",
                  placeholder: "Puerto SMTP"
                },
                model: {
                  value: _vm.form.smtp_alertas_port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_port", $$v)
                  },
                  expression: "form.smtp_alertas_port"
                }
              },
              [
                _c("span", [_vm._v("Puerto SMTP (Alertas de saldos)")]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_port
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_port[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("p", [
          _c("label", { attrs: { for: "smtp_alertas_tls" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.smtp_alertas_tls,
                  expression: "form.smtp_alertas_tls"
                }
              ],
              attrs: {
                type: "checkbox",
                name: "smtp_alertas_tls",
                id: "smtp_alertas_tls"
              },
              domProps: {
                checked: Array.isArray(_vm.form.smtp_alertas_tls)
                  ? _vm._i(_vm.form.smtp_alertas_tls, null) > -1
                  : _vm.form.smtp_alertas_tls
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.smtp_alertas_tls,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.form,
                          "smtp_alertas_tls",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "smtp_alertas_tls",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "smtp_alertas_tls", $$c)
                  }
                }
              }
            }),
            _c("span", [_vm._v("SSL/TLS SMTP (Alertas de saldos)")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "smtp_alertas_usuario",
                  placeholder: "Usuario SMTP"
                },
                model: {
                  value: _vm.form.smtp_alertas_usuario,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_usuario", $$v)
                  },
                  expression: "form.smtp_alertas_usuario"
                }
              },
              [
                _c("span", [_vm._v("Usuario SMTP (Alertas de saldos)")]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_usuario
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_usuario[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "smtp_alertas_password",
                  placeholder: "Contraseña SMTP"
                },
                model: {
                  value: _vm.form.smtp_alertas_password,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_password", $$v)
                  },
                  expression: "form.smtp_alertas_password"
                }
              },
              [
                _c("span", [_vm._v("Contraseña SMTP (Alertas de saldos)")]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_password
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_password[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "######",
                    expression: "'######'"
                  }
                ],
                attrs: {
                  type: "tel",
                  id: "smtp_alertas_dias_antelacion",
                  placeholder: "# Días"
                },
                model: {
                  value: _vm.form.smtp_alertas_dias_antelacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_dias_antelacion", $$v)
                  },
                  expression: "form.smtp_alertas_dias_antelacion"
                }
              },
              [
                _c("span", [_vm._v("Días de antelación")]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_dias_antelacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.errores.smtp_alertas_dias_antelacion[0]
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "email",
                  id: "smtp_alertas_correo_emisor",
                  placeholder: "Escriba el correo de emisión..."
                },
                model: {
                  value: _vm.form.smtp_alertas_correo_emisor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_correo_emisor", $$v)
                  },
                  expression: "form.smtp_alertas_correo_emisor"
                }
              },
              [
                _c("span", [
                  _vm._v("Correo de emisor SMTP (Alertas de saldos)")
                ]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_correo_emisor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_correo_emisor[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "smtp_alertas_nombre_emisor",
                  placeholder: "Escriba el nombre del emisor..."
                },
                model: {
                  value: _vm.form.smtp_alertas_nombre_emisor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_alertas_nombre_emisor", $$v)
                  },
                  expression: "form.smtp_alertas_nombre_emisor"
                }
              },
              [
                _c("span", [
                  _vm._v("Nombre de emisor SMTP (Alertas de saldos)")
                ]),
                _vm._v(" "),
                _vm.errores.smtp_alertas_nombre_emisor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_alertas_nombre_emisor[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-sign-out" }),
          _vm._v(" "),
          _c("span", [_vm._v("Cerrar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardarCambios }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Guardar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Preferencias")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-839d428a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-839d428a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue
// module id = 505
// module chunks = 0